import axios from "axios";
import { FRAPPE_BASE_URL } from "@/services/frappe/config";

export const axiosInstance = axios.create({
  baseURL: FRAPPE_BASE_URL,
  timeout: 15000, // ms
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});


    
